/*
|--------------------------------------------------------------------------
| Analytics: Google: Classic
|--------------------------------------------------------------------------
*/

/**
 * @namespace
 */
__gh__webApp.analytics.google.classic = {

	/**
	 * Initialize google analytics
	 */
	"init": function(){
		this.trackMain();
		this.trackAccounts();
		this.loadLibrary();
	},


	/**
	 * Load the google analytics library
	 */
	"loadLibrary": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		(function() {var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; ga.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'stats.g.doubleclick.net/dc.js';var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s);})();
	},


	/**
	 * Main tracking code for the site.
	 */
	"trackMain": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 	= __gh__coreData["3rdPartyData"].analytics.google,
			ua 			= (analytics.ua) ? analytics.ua : null;
			window._gaq = window._gaq || [];

		if(!ua){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.classic.trackMain",message:"Missing ua code."});
			return;
		}

		window._gaq.push(
			['_setAccount', ''+ua+''],
			['_setDomainName', 'none'],
			['_setAllowLinker', true],
			['_trackPageview']
		);
	},

	/**
	 * Main tracking code for additional accounts.
	 */
	"trackAccounts": function(){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 	= __gh__coreData["3rdPartyData"].analytics.google,
			accounts 	= (analytics.accounts) 	? analytics.accounts 	: null;
			window._gaq	= window._gaq || [];

		if(!accounts){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.classic.trackAccounts",message:"Missing accounts ua code."});
			return;
		}

		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
			   window._gaq.push(
			        [''+key+'._setAccount', ''+accounts[key]+''],
					[''+key+'._trackPageview']
		        );
			}
		}
	},

	/**
	 * Track a page element
	 *
	 * @param {object} options
	 * @param {string} options.path - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} [options.title=null] - The title of the page (e.g. homepage)
	 */
	"trackElement": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		this.trackPage(options);
	},

	/**
	 * Track an event
	 *
	 * @param {object} options
	 * @param {string} options.category - object that's interacted with
	 * @param {string} [options.action="click"] - The action event ie. ("click","play","hover","log","etc)
	 * @param {string} [options.label=null] - Useful for categorizing events (e.g. 'Fall Campaign')
	 * @param {number} [options.value=null] - A numeric value associated with the event (e.g. 42)
	 * @param {boolean} [options.nonInteraction=false] - Event is a noninteraction event.
	 * @example <caption>NonInteraction event example.</caption>
	 * __gh__webApp.analytics.google.trackEvent({"path":"/dev-event","action":"log","value": 1,"nonInteraction":true});
	 * @example <caption>Click event example.</caption>
	 * __gh__webApp.analytics.google.trackEvent({"path":"/dev-event"});
	 */
	"trackEvent": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }

		var analytics 		= __gh__coreData["3rdPartyData"].analytics.google,
			ua 				= (analytics.ua) 		? analytics.ua 			: null,
			accounts 		= (analytics.accounts) 	? analytics.accounts 	: null,
			eventSettings	= {
				"ua"	: (ua) ? ['_setAccount', ''+ua+'']: null,
				"event"	: [
					'_trackEvent',
					'event',
					(options.category) 			? options.category 	: null,
					(options.action) 			? options.action 	: "click",
					(options.label) 			? options.label 	: null,
					(options.value) 			? options.value 	: null,
					(options.nonInteraction) 	? true 				: false,
				]
			};

		if(!options.category){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.classic.trackEvent",message:"Missing category."});
			return;
		}

		for(var key in eventSettings){
			if(eventSettings[key]){
			   window._gaq.push(eventSettings[key]);
			}
		}


		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
				for(var eventKey in eventSettings){
					if(eventSettings[eventKey]){
						eventSettings['ua'] 		= [''+key+'._setAccount',accounts[key]];
						eventSettings['event'][0] 	= key+'._trackEvent';
						console.log(eventSettings[eventKey][0]);
						window._gaq.push(eventSettings[eventKey]);
					}
				}
			}
		}
	},


	/**
	 * Track a page view
	 *
	 * @param {object} options
	 * @param {string} options.path - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} [options.title=null] - The title of the page (e.g. homepage)
	 */
	"trackPage": function(options){
		var track = __gh__coreData.siteData.providers.analytics.track;
		if (!track) { return; }
	
		var analytics 	= __gh__coreData["3rdPartyData"].analytics.google,
			commonJS	= __gh__webApp.common,
			ua 			= (analytics.ua) ? analytics.ua : null,
			path		= (options.path) ? options.path : null,
			url			= (options.url) ? commonJS.getURLParts(options.url) : null,
			path 		= (url) ? url.pathname : path;
			accounts 	= (analytics.accounts) ? analytics.accounts : null;
			window._gaq = window._gaq || [];
	
		if(!path){
			__gh__webApp.utilities.errorLog({controller:"__gh__webApp.analytics.google.classic.trackPage",message:"Missing path."});
			return;
		}
		
		// main
		var pageViewSettings = {
			"ua"	: (ua) 				? ['_setAccount', ''+ua+''] 				: null,
			"title" : (options.title) 	? ['_set', 'title', ''+options.title+''] 	: null,
			"path"	: (path) 	? ['_trackPageview', ''+path+''] 	: null
		}
		for(var key in pageViewSettings){
			if(pageViewSettings[key]){
			   window._gaq.push(pageViewSettings[key]);
			}
		}
	
		// accounts
		for(var key in accounts){
			if(accounts.hasOwnProperty(key)){
				pageViewSettingsNew 			= $.extend(true,{},pageViewSettings);
				pageViewSettingsNew['ua'][1] 	= accounts[key];
				for(var pgKey in pageViewSettingsNew){
					if(pageViewSettingsNew[pgKey]){
						pageViewSettingsNew[pgKey][0] = key+'.'+pageViewSettings[pgKey][0];
						window._gaq.push(pageViewSettingsNew[pgKey]);
					}
				}
			}
		}
	},

	/**
	 * Track a social Interaction
	 *
	 * @param {object} options
	 * @param {string} [options.hitType=social] - The path portion of a URL. This value should start with a slash (/) character.
	 * @param {string} options.socialNetwork - The network on which the action occurs (e.g. Facebook, Twitter)
	 * @param {string} options.socialAction - The type of action that happens (e.g. Like, Send, Tweet)
	 * @param {string} options.socialTarget - Specifies the target of a social interaction. This value is typically a URL but can be any text. (e.g. http://mycoolpage.com)
	 */
	"trackSocial": function(options){

	}

};
